import React from 'react';
import PropTypes from 'prop-types';
import * as Style from './style';
import Button from '../Button';
import Car from '../../../img/car2.png';
import CarSilver from '../../../img/silvercar.png';
import CarBlack from '../../../img/chevrolet-4-onix-premier-preto-ouro-negro.png';

const Banner = ({ hasProduct }) => (hasProduct ? (
	<Style.BannerBackground>
		<div className="d-flex flex-column justify-content-center" style={{ height: '100%' }}>
			<Style.MainText>O seu site feito por especialistas Webmotors</Style.MainText>
			<Style.Text>Líderes de mercado para inovar na forma de
				<br />comprar e vender carros e motos.
			</Style.Text>
		</div>
		<Style.CarImg src={CarBlack} alt="" zindex="0" />
		<Style.CarImg src={CarSilver} alt="" zindex="1" />
	</Style.BannerBackground>
) : (
	<Style.BannerBackground>
		<img src={Car} alt="/" />
		<Style.Banner>
			<div className="row">
				<div className="col-12">
					<div className="row">
						<div className="col-12">
							<Style.Title>CAMPANHAS!</Style.Title>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<Style.Text>
								Bem-vindo ao produto Webmotors que fará a sua loja bombar em vendas! <br /> {}
								Aqui ficam as soluções para promover e impulsionar sua loja na internet! <br /> {}
								Alcance seus clientes, onde quer que eles estejam!
							</Style.Text>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<Button style={{ width: '292px', height: '40px' }} type="link" to="/campanhas/nova-campanha">Crie sua campanha agora mesmo</Button>
						</div>
					</div>
				</div>
			</div>
		</Style.Banner>
	</Style.BannerBackground>
    ));
Banner.defaultProps = {
    hasProduct: false,
};

PropTypes.Banner = {
    hasProduct: PropTypes.boolean,
};

export default Banner;
